import { Component, inject, output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getApiErrorMessage } from 'src/app/_helpers/api-error.helpers';
import { CancellationService } from 'src/app/_services/cancellation.service';
import { CancellationFlowDetailsResponse } from 'src/app/_types/cancellation.types';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

/**
 * « Marquer la lettre comme envoyée »: the step once the customer has signed
 * (finalising follows). The partner got the signed letter to the insurer
 * themselves and records it here; the cancellation becomes SENT and the
 * refreshed one is handed up as `changed`.
 */
@Component({
  selector: 'app-cancellation-send-modal',
  standalone: true,
  imports: [ActionModalComponent, IconsModule],
  templateUrl: './cancellation-send-modal.component.html',
  styleUrl: './cancellation-send-modal.component.css',
})
export class CancellationSendModalComponent {
  private readonly cancellationService = inject(CancellationService);

  private readonly toastr = inject(ToastrService);

  /** The route landed: the refreshed cancellation. */
  readonly changed = output<CancellationFlowDetailsResponse>();

  @ViewChild('actionModal')
  private actionModal?: ActionModalComponent;

  private cancellation: CancellationFlowDetailsResponse | null = null;

  protected submitted = false;

  openModal(cancellation: CancellationFlowDetailsResponse): void {
    this.cancellation = cancellation;
    this.submitted = false;
    this.actionModal?.openModal();
  }

  closeModal(): void {
    this.actionModal?.closeModal();
  }

  protected confirm(): void {
    const id = this.cancellation?.id;
    if (!id || this.submitted) return;
    this.submitted = true;
    this.cancellationService.markSentToInsurer(id).subscribe({
      next: (res) => {
        this.submitted = false;
        this.toastr.success(
          $localize`Lettre marquée comme envoyée à l'assureur`
        );
        this.changed.emit(res.data);
        this.actionModal?.closeModal();
      },
      error: (err) => {
        this.submitted = false;
        this.toastr.error(
          getApiErrorMessage(
            err,
            $localize`Une erreur est survenue. Veuillez réessayer`
          )
        );
      },
    });
  }
}
